'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactDock = require('react-dock');
var _reactDock2 = _interopRequireDefault(_reactDock);
var _NavItem = require('./NavItem');
var _NavItem2 = _interopRequireDefault(_NavItem);
var _NavItemExpandable = require('./NavItemExpandable');
var _NavItemExpandable2 = _interopRequireDefault(_NavItemExpandable);
var _recentlyVisited = require('./recentlyVisited');
var _recentlyVisited2 = _interopRequireDefault(_recentlyVisited);
var _Logo = require('../Logo');
var _Logo2 = _interopRequireDefault(_Logo);
var _hamburger = require('@cimpress/react-components/lib/shapes/hamburger');
var _config = require('../Services/config');
var _headerFallbackNavLinks = require('./headerFallbackNavLinks');
var _headerFallbackNavLinks2 = _interopRequireDefault(_headerFallbackNavLinks);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// Today, this is a constant file we maintain. In the future, it will likely be a service.
var HEADER_CONTENTS_URL = 'https://static.ux.cimpress.io/mcp-header/v2/menuitems';
var SideNav = function (_Component) {
  _inherits(SideNav, _Component);
  function SideNav() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, SideNav);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SideNav.__proto__ || Object.getPrototypeOf(SideNav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.componentDidMount = function () {
      if (_this.state.sideNavItems) {
        // items have already been loaded, so we're good.
        return;
      }
      _this._isMounted = true;
      (0, _config.getSideNav)().then(function (responseObj) {
        if (!_this._isMounted) {
          return false;
        }
        _this.setState({
          sideNavItems: responseObj
        });
      });
    }, _this.componentWillUnmount = function () {
      _this._isMounted = false;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(SideNav, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        sideNavOpen = _props.sideNavOpen,
        toggleSideNav = _props.toggleSideNav,
        language = _props.language,
        environment = _props.environment,
        accessToken = _props.accessToken;
      var sideNavItems = this.state.sideNavItems;
      var _ref2 = sideNavItems || {},
        heroItems = _ref2.heroItems,
        footerItems = _ref2.footerItems;
      return _react2.default.createElement(_reactDock2.default, {
        isVisible: sideNavOpen,
        onVisibleChange: toggleSideNav,
        size: 340,
        fluid: false,
        dimStyle: {
          background: 'rgba(255, 255, 255, 0.5)'
        }
      }, _react2.default.createElement('div', {
        className: 'sidenav',
        style: {
          position: 'initial',
          width: 'auto',
          height: 'auto',
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column'
        }
      }, _react2.default.createElement('nav', {
        className: 'navbar navbar-inverse clickable',
        onClick: toggleSideNav
      }, _react2.default.createElement('span', {
        className: 'hamburger'
      }, _react2.default.createElement(_hamburger.Close, null)), _react2.default.createElement('a', {
        className: 'navbar-brand'
      }, _react2.default.createElement(_Logo2.default, {
        width: '107px',
        inverse: true
      }))), _react2.default.createElement('div', {
        className: 'list-group'
      }, heroItems ? heroItems.map(function (item) {
        return _react2.default.createElement(_NavItem2.default, {
          item: {
            id: item.id,
            text: item.text,
            svg: item.svg,
            url: item.url
          },
          isActive: true,
          key: item.id
        });
      }) : null, _react2.default.createElement(_recentlyVisited2.default, {
        accessToken: accessToken
      })), _react2.default.createElement('hr', {
        style: {
          marginBottom: '20px'
        }
      }), _react2.default.createElement(StandardSideNavLinks, {
        language: language,
        environment: environment,
        accessToken: accessToken
      }), _react2.default.createElement('div', {
        className: 'list-group',
        style: {
          flexGrow: '1',
          display: 'flex',
          flexDirection: 'column'
        }
      }, _react2.default.createElement('div', {
        style: {
          flexGrow: '1'
        }
      }), _react2.default.createElement('hr', {
        style: {
          marginBottom: '20px'
        }
      }), footerItems ? footerItems.map(function (item) {
        return _react2.default.createElement(_NavItem2.default, {
          item: {
            id: item.id,
            text: item.text,
            svg: item.svg,
            url: item.url
          },
          isActive: true,
          key: item.id
        });
      }) : null)));
    }
  }]);
  return SideNav;
}(_react.Component);
exports.default = SideNav;
SideNav.propTypes = {
  sideNavOpen: _propTypes2.default.bool,
  toggleSideNav: _propTypes2.default.func,
  language: _propTypes2.default.string,
  environment: _propTypes2.default.string,
  accessToken: _propTypes2.default.string
};
var StandardSideNavLinks = function (_Component2) {
  _inherits(StandardSideNavLinks, _Component2);
  function StandardSideNavLinks(props) {
    _classCallCheck(this, StandardSideNavLinks);
    var _this2 = _possibleConstructorReturn(this, (StandardSideNavLinks.__proto__ || Object.getPrototypeOf(StandardSideNavLinks)).call(this, props));
    _this2.componentWillUnmount = function () {
      _this2._isMounted = false;
    };
    _this2.state = {
      itemList: null
    };
    return _this2;
  }
  _createClass(StandardSideNavLinks, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;
      if (this.state.itemList) {
        // items have already been loaded, so we're good.
        return;
      }
      this._isMounted = true;
      (0, _config.getMenuItems)().then(function (responseObj) {
        if (!_this3._isMounted) {
          return false;
        }
        _this3.setState({
          itemList: responseObj.items
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;
      var itemList = this.state.itemList;
      if (!itemList) {
        // should we be using an empty list here?
        // this indicates we haven't yet gotten any response back from the fetch, but are being forced to render anyway...
        itemList = _headerFallbackNavLinks2.default;
      }
      var items = itemList.map(function (item) {
        if (!item.text) {
          return;
        }
        var isActive = _this4.props.activeNavLinkId === item.id ? 'active' : '';
        return item.subItems ? _react2.default.createElement(_NavItemExpandable2.default, {
          item: item,
          isActive: isActive,
          key: item.id
        }) : _react2.default.createElement(_NavItem2.default, {
          item: item,
          isActive: isActive,
          key: item.id
        });
      });
      return _react2.default.createElement('div', {
        className: 'list-group'
      }, items);
    }
  }]);
  return StandardSideNavLinks;
}(_react.Component);
var linkPropType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  id: _propTypes2.default.string,
  url: _propTypes2.default.string,
  glyphicon: _propTypes2.default.string,
  iconUrl: _propTypes2.default.string,
  text: _propTypes2.default.string
}));
StandardSideNavLinks.propTypes = {
  language: _propTypes2.default.string,
  environment: _propTypes2.default.string,
  activeNavLinkId: _propTypes2.default.string,
  fallbackNavLinks: linkPropType
};